import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { IoMdClose } from "react-icons/io";

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;


  return `${formattedDate}`;
}

function formatTime(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;
  return `${formattedTime}`;
}

export default function ApprovalHistory(props) {
  
  // console.log("propsathistory",props.data);
  

  return (
    <React.Fragment>  
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <Box sx={{position:"absolute",top:5,right:5,cursor:"pointer",fontSize:"25px"}} onClick={()=>props.handleClose()}> 
          <IoMdClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
        <Typography variant='h4'>History</Typography>
        </DialogTitle>
        <DialogContent>
          {
            props.data?
            <table>
              <tr>
                  <td><Typography variant='h4'>DS Requested at</Typography></td>
                  <td>:</td>
                  <td>{formatDate(props.data.ds_requested_at)} / {formatTime(props.data.ds_requested_at)}</td>
              </tr>
              <tr>
                  <td><Typography variant='h4'>SH Approved on</Typography></td>
                  <td>:</td>
                  <td>{formatDate(props.data.sh_approved_on)} / {formatTime(props.data.sh_approved_on)}</td>
              </tr>
              <tr>
                  <td><Typography variant='h4'>RM Approved on</Typography></td>
                  <td>:</td>
                  <td>{formatDate(props.data.rm_approved_on)} / {formatTime(props.data.rm_approved_on)}</td>
              </tr>
              
          </table>
          :
          null
          }
          
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Close</Button>
         
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
